export const FEATURE_FLAGS = {
    /**
     * Gates the Marketing Center checklist work in the Coaching Portal: the destination badge
     * on play rows, the "View in" filter, and the destination selector on play creation.
     * Owned in the Keap feature flag service as keap.coachingportal.mc.checklist.
     */
    marketingCenterChecklist: 'keap.coachingportal.mc.checklist',
    copyGeneratorNav: 'keap.copy.generator.nav',
} as const;

export type FeatureFlagName = typeof FEATURE_FLAGS[keyof typeof FEATURE_FLAGS];

// Array of all flags to fetch by default
export const DEFAULT_FEATURE_FLAGS = [
    FEATURE_FLAGS.marketingCenterChecklist,
    FEATURE_FLAGS.copyGeneratorNav,
] as const;
